import { render } from "./IconographyView.vue?vue&type=template&id=83c30e4a&scoped=true"
import script from "./IconographyView.vue?vue&type=script&lang=js"
export * from "./IconographyView.vue?vue&type=script&lang=js"

import "./IconographyView.vue?vue&type=style&index=0&id=83c30e4a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83c30e4a"]])

export default __exports__